import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkout } from '../../../../common/types/checkout';
import { FormDataShape } from '../../../../common/hooks/useCheckoutController/useCheckoutController.types';
import { ZipCodeInputModern } from '../../../molecules/modern/zip-code-input/zip-code-input.molecule';
import { formatCurrency } from '../../../../common/utils/format-currency';
import * as S from './delivery-form-modern.organism.style';

type Props = {
  checkout: Checkout;
  formData: FormDataShape;
  setFormData: (field: keyof FormDataShape, value: string) => void;
};

export const DeliveryFormModern: React.FC<Props> = ({
  checkout,
  formData,
  setFormData,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <S.Fieldset>
        <legend>{t('delivery')}</legend>
        <div className="grid grid-2">
          <ZipCodeInputModern
            id="postalCode"
            country={checkout?.paisEnum}
            value={formData.postalCode}
            onChange={(value) => setFormData('postalCode', value)}
            label={t('postalCode')}
          />
          <S.InputWrap>
            <input
              placeholder=" "
              value={formData.state}
              onChange={(e) => setFormData('state', e.target.value)}
            />
            <label>{t('state')}*</label>
          </S.InputWrap>
          <S.InputWrap>
            <input
              placeholder=" "
              value={formData.city}
              onChange={(e) => setFormData('city', e.target.value)}
            />
            <label>{t('city')}*</label>
          </S.InputWrap>
          <S.InputWrap className="span-2">
            <input
              placeholder=" "
              value={formData.neighborhood}
              onChange={(e) => setFormData('neighborhood', e.target.value)}
            />
            <label>{t('district')}*</label>
          </S.InputWrap>
          <S.InputWrap className="span-2">
            <input
              placeholder=" "
              value={formData.address}
              onChange={(e) => setFormData('address', e.target.value)}
            />
            <label>{t('address')}*</label>
          </S.InputWrap>
          <S.InputWrap className="span-2">
            <input
              placeholder=" "
              value={formData.number}
              onChange={(e) => setFormData('number', e.target.value)}
            />
            <label>{t('number')}*</label>
          </S.InputWrap>
          <S.InputWrap className="span-2">
            <input
              placeholder=" "
              value={formData.complement}
              onChange={(e) => setFormData('complement', e.target.value)}
            />
            <label>{t('complement')}</label>
          </S.InputWrap>
        </div>

        {(!formData?.postalCode || formData?.postalCode?.length === 0) && (
          <S.InlineMsg>{t('cannotCalculateSalesTax')}</S.InlineMsg>
        )}
      </S.Fieldset>

      <S.ShippingFieldset>
        <legend>{t('deliveryMethod')}</legend>
        {!formData?.postalCode || formData?.postalCode?.length === 0 ? (
          <div className="label">{t('enterShippingAddressToViewMethods')}</div>
        ) : (
          <S.ShippingOption active>
            <input type="radio" checked readOnly />
            <span className="dot" />
            <span style={{ flex: 1 }}>{t('free')}</span>
            <span style={{ fontWeight: 600 }}>
              {formatCurrency(0, checkout?.moeda)}
            </span>
          </S.ShippingOption>
        )}
      </S.ShippingFieldset>
    </>
  );
};
